/* tslint:disable */
/* eslint-disable */
/**
 * OU-AAO API
 * This is a definition of Osaka University AAD Application API.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: t.shinohara@mmj.ne.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface PasswordChangeRequest
 */
export interface PasswordChangeRequest {
  /**
   *
   * @type {string}
   * @memberof PasswordChangeRequest
   */
  currentPassword: string
  /**
   *
   * @type {string}
   * @memberof PasswordChangeRequest
   */
  newPassword: string
}

export function PasswordChangeRequestFromJSON(json: any): PasswordChangeRequest {
  return PasswordChangeRequestFromJSONTyped(json, false)
}

export function PasswordChangeRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PasswordChangeRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    currentPassword: json['currentPassword'],
    newPassword: json['newPassword'],
  }
}

export function PasswordChangeRequestToJSON(value?: PasswordChangeRequest | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    currentPassword: value.currentPassword,
    newPassword: value.newPassword,
  }
}
